import React from 'react'
import { Col, Card } from 'react-bootstrap'
import { formatCurrency, IsSpecialEmployer } from '../../../helpers'
import Tooltip from '../../tooltip'
import { Icon as RemServIcon } from 'RemServ/icons'
import { Icon as MaxxiaIcon } from 'Maxxia/icons'
import globals from 'application/constants/globals'
import * as E from './runningSectionElements'

interface IInputProps {
  icon: string
  iconSize?: number
  id: string | undefined
  title: string
  value: any
  tooltip: { header?: string; subHeading?: string; text: string }
  isExGST?: boolean
}

const ColItem = (props: IInputProps) => {
  let isACTGO = IsSpecialEmployer('ACTGO')

  return props.value &&
    ((!!props.value.incGST && !!props.value.exGST) ||
      (typeof props.value !== 'object' && !!props.value)) ? (
    <Col xs={12} md={6} className="mb-12">
      <Card>
        <Card.Body className="d-flex py-2 justify-content-between">
          <div className="d-flex">
            {globals.isBrandRS && (
              <RemServIcon
                iconType={props.icon}
                size={props.iconSize ? props.iconSize : 1.4}
                primary
              />
            )}
            {globals.isBrandMX && (
              <MaxxiaIcon
                iconType={props.icon}
              />
            )}
            <div className="d-flex flex-column ml-2">
              <E.CardTitleSpan>{props.title}</E.CardTitleSpan>
              {typeof props.value === 'object' && (globals.isBrandRS || isACTGO) ? (
                <>
                  <div>
                    <E.CardAmountSpan>
                      {formatCurrency(props.value.incGST)}
                    </E.CardAmountSpan>{' '}
                    <E.CardGSTAmountSpan>(Inc GST)</E.CardGSTAmountSpan>
                  </div>
                  <div>
                    <E.CardAmountSpan>
                      {formatCurrency(props.value.exGST)}{' '}
                    </E.CardAmountSpan>{' '}
                    <E.CardGSTAmountSpan>(Ex GST)</E.CardGSTAmountSpan>
                  </div>
                </>
              ) : typeof props.value === 'object' && globals.isBrandMX && !isACTGO ? (
                <E.CardAmountSpan
                  id={props.id ? props.id + '.value' : undefined}
                >
                  {props.isExGST
                    ? formatCurrency(props.value.exGST)
                    : formatCurrency(props.value.incGST)}
                </E.CardAmountSpan>
              ) : (
                <E.CardAmountSpan
                  id={props.id ? props.id + '.value' : undefined}
                >
                  {isNaN(props.value)
                    ? props.value
                    : formatCurrency(props.value)}
                </E.CardAmountSpan>
              )}
            </div>
          </div>
          <Tooltip
            header={props.tooltip.header || props.title}
            subHeading={globals.isBrandRS && props.tooltip.subHeading}
            text={props.tooltip.text}
          />
        </Card.Body>
      </Card>
    </Col>
  ) : null
}

export default ColItem
